// Lightweight per-route SEO: updates title, meta description and canonical for
// JS-rendering crawlers. Static crawlers read the defaults baked into index.html.
export function setSeo({ title, description, canonical } = {}) {
  if (title) document.title = title;

  if (description) {
    let m = document.querySelector('meta[name="description"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "description");
      document.head.appendChild(m);
    }
    m.setAttribute("content", description);
  }

  if (canonical) {
    let l = document.querySelector('link[rel="canonical"]');
    if (!l) {
      l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      document.head.appendChild(l);
    }
    l.setAttribute("href", canonical);
  }
}
